import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallMultiSelectErrorSlideout extends Layout {
    labelErrorCount: Label;
    labelErrors: Label;
    labelFailed: Label;
    labelFailedCount: Label;
    panelErrors: Panel;
    panelFailed: Panel;
    sourceBrokerageMovements: DataSource;
    tableErrors: Table;
    tableFailed: Table;
}
